import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import {
    SectionThreeImagesEightTextsBody,
    SectionThreeImagesEightTextsDetails,
} from "types/api/blocks/sectionThreeImagesEightTexts";

function useSectionThreeImagesEightTextsApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionThreeImagesEightTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionThreeImagesEightTextsDetails> => {
        return get<PathParamsWithId, undefined, SectionThreeImagesEightTextsDetails>({
            url: "/blocks/section-three-images-eight-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionThreeImagesEightTexts = React.useCallback((body: SectionThreeImagesEightTextsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionThreeImagesEightTextsBody, null>({
            url: "/blocks/section-three-images-eight-texts",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionThreeImagesEightTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-three-images-eight-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionThreeImagesEightTexts,
        saveSectionThreeImagesEightTexts,
        deleteSectionThreeImagesEightTexts
    };
}

export default useSectionThreeImagesEightTextsApi;